define("hqwebapp/js/bootstrap3/common", [
    'jquery',
    'knockout',
    'ko.mapping',
    'underscore',
    'bootstrap',
], function () {
    // nothing to do, this is just to define the major common dependencies for HQ
});
